import { normalize } from 'normalizr';

import api from '../../api';
import { schema } from '../../schema';
import { addEntities, removeEntity } from '../../actions';
import Format from '../../../lib/Format';
import Logger from '../../../lib/Logger';

// ACTION TYPES

export const COGNITO_FORM_LIST_REQUEST = 'COGNITO_FORM_LIST_REQUEST';
export const COGNITO_FORM_LIST_SUCCESS = 'COGNITO_FORM_LIST_SUCCESS';
export const COGNITO_FORM_LIST_FAILURE = 'COGNITO_FORM_LIST_FAILURE';
export const COGNITO_FORM_READ_REQUEST = 'COGNITO_FORM_READ_REQUEST';
export const COGNITO_FORM_READ_SUCCESS = 'COGNITO_FORM_READ_SUCCESS';
export const COGNITO_FORM_READ_FAILURE = 'COGNITO_FORM_READ_FAILURE';
export const COGNITO_FORM_UPDATE_REQUEST = 'COGNITO_FORM_UPDATE_REQUEST';
export const COGNITO_FORM_UPDATE_SUCCESS = 'COGNITO_FORM_UPDATE_SUCCESS';
export const COGNITO_FORM_UPDATE_FAILURE = 'COGNITO_FORM_UPDATE_FAILURE';
export const COGNITO_FORM_CREATE_REQUEST = 'COGNITO_FORM_CREATE_REQUEST';
export const COGNITO_FORM_CREATE_SUCCESS = 'COGNITO_FORM_CREATE_SUCCESS';
export const COGNITO_FORM_CREATE_FAILURE = 'COGNITO_FORM_CREATE_FAILURE';
export const COGNITO_FORM_DELETE_REQUEST = 'COGNITO_FORM_DELETE_REQUEST';
export const COGNITO_FORM_DELETE_SUCCESS = 'COGNITO_FORM_DELETE_SUCCESS';
export const COGNITO_FORM_DELETE_FAILURE = 'COGNITO_FORM_DELETE_FAILURE';
export const COGNITO_FORM_FORM_DESTROY = 'COGNITO_FORM_FORM_DESTROY';
export const COGNITO_FORM_CSV_DOWNLOAD_REQUEST =
  'COGNITO_FORM_CSV_DOWNLOAD_REQUEST';
export const COGNITO_FORM_CSV_DOWNLOAD_SUCCESS =
  'COGNITO_FORM_CSV_DOWNLOAD_SUCCESS';
export const COGNITO_FORM_CSV_DOWNLOAD_FAILURE =
  'COGNITO_FORM_CSV_DOWNLOAD_FAILURE';

// ACTION CREATORS

export function cognitoFormListRequest(page, limit, order, filter) {
  Logger.log(
    'debug',
    `[state.cognitoForms.actions] cognitoFormListRequest(${page}, ${limit}, ${order}, %j)`,
    filter
  );
  return {
    type: COGNITO_FORM_LIST_REQUEST,
    page: page,
    limit: limit,
    order: order,
    filter: filter,
  };
}

export function cognitoFormListSuccess(data) {
  Logger.log(
    'debug',
    `[state.cognitoForms.actions] cognitoFormListSuccess(%j)`,
    data
  );
  return {
    type: COGNITO_FORM_LIST_SUCCESS,
    page: data.page,
    limit: data.limit,
    order: data.order,
    result: data.result,
    total: data.total,
    receivedAt: Date.now(),
  };
}

export function cognitoFormListFailure(error) {
  Logger.log(
    'debug',
    `[state.cognitoForms.actions] cognitoFormListFailure(%j)`,
    error
  );
  return {
    type: COGNITO_FORM_LIST_FAILURE,
    error: error,
  };
}

export function cognitoFormReadRequest(id) {
  Logger.log(
    'debug',
    `[state.cognitoForms.actions] cognitoFormReadRequest(${id})`
  );
  return {
    type: COGNITO_FORM_READ_REQUEST,
    id: id,
  };
}

export function cognitoFormReadSuccess(data) {
  Logger.log(
    'debug',
    `[state.cognitoForms.actions] cognitoFormReadSuccess(%j)`,
    data
  );
  return {
    type: COGNITO_FORM_READ_SUCCESS,
    id: data.id,
    receivedAt: Date.now(),
  };
}

export function cognitoFormReadFailure(error) {
  Logger.log(
    'debug',
    `[state.cognitoForms.actions] cognitoFormReadFailure(%j)`,
    error
  );
  return {
    type: COGNITO_FORM_READ_FAILURE,
    error: error,
  };
}

export function cognitoFormUpdateRequest(id, data) {
  Logger.log(
    'debug',
    `[state.cognitoForms.actions] cognitoFormUpdateRequest(${id}, %j)`,
    data
  );
  return {
    type: COGNITO_FORM_UPDATE_REQUEST,
  };
}

export function cognitoFormUpdateSuccess(data) {
  Logger.log(
    'debug',
    `[state.cognitoForms.actions] cognitoFormUpdateSuccess(%j)`,
    data
  );
  return {
    type: COGNITO_FORM_UPDATE_SUCCESS,
    id: data.id,
    receivedAt: Date.now(),
  };
}

export function cognitoFormUpdateFailure(error) {
  Logger.log(
    'debug',
    `[state.cognitoForms.actions] cognitoFormUpdateFailure(%j)`,
    error
  );
  return {
    type: COGNITO_FORM_UPDATE_FAILURE,
    error: error,
  };
}

export function cognitoFormCreateRequest(data) {
  Logger.log(
    'debug',
    `[state.cognitoForms.actions] cognitoFormCreateRequest(%j)`,
    data
  );
  return {
    type: COGNITO_FORM_CREATE_REQUEST,
  };
}

export function cognitoFormCreateSuccess(data) {
  Logger.log(
    'debug',
    `[state.cognitoForms.actions] cognitoFormCreateSuccess(%j)`,
    data
  );
  return {
    type: COGNITO_FORM_CREATE_SUCCESS,
    id: data.id,
    receivedAt: Date.now(),
  };
}

export function cognitoFormCreateFailure(error) {
  Logger.log(
    'debug',
    `[state.cognitoForms.actions] cognitoFormCreateFailure(%j)`,
    error
  );
  return {
    type: COGNITO_FORM_CREATE_FAILURE,
    error: error,
  };
}

export function cognitoFormDeleteRequest(id) {
  Logger.log(
    'debug',
    `[state.cognitoForms.actions] cognitoFormDeleteRequest(${id})`
  );
  return {
    type: COGNITO_FORM_DELETE_REQUEST,
    id: id,
  };
}

export function cognitoFormDeleteSuccess(id) {
  Logger.log(
    'debug',
    `[state.cognitoForms.actions] cognitoFormDeleteSuccess(${id})`
  );
  return {
    type: COGNITO_FORM_DELETE_SUCCESS,
    id: id,
  };
}

export function cognitoFormDeleteFailure(error) {
  Logger.log(
    'debug',
    `[state.cognitoForms.actions] cognitoFormDeleteFailure(%j)`,
    error
  );
  return {
    type: COGNITO_FORM_DELETE_FAILURE,
    error: error,
  };
}

export function cognitoFormsFormDestroy(formState = null) {
  Logger.log(
    'debug',
    `[state.cognitoForms.actions] cognitoFormsFormDestroy(%j)`,
    formState
  );
  return {
    type: COGNITO_FORM_FORM_DESTROY,
    form: formState,
  };
}

export function cognitoFormCSVDownloadRequest(order, filter) {
  Logger.log(
    'debug',
    `[state.cognitoForms.actions] cognitoFormCSVDownloadRequest()`
  );
  return {
    type: COGNITO_FORM_CSV_DOWNLOAD_REQUEST,
    order: order,
    filter: filter,
  };
}

export function cognitoFormCSVDownloadSuccess() {
  Logger.log(
    'debug',
    `[state.cognitoForms.actions] cognitoFormCSVDownloadSuccess()`
  );
  return {
    type: COGNITO_FORM_CSV_DOWNLOAD_SUCCESS,
  };
}

export function cognitoFormCSVDownloadFailure() {
  Logger.log(
    'debug',
    `[state.cognitoForms.actions] cognitoFormCSVDownloadFailure()`
  );
  return {
    type: COGNITO_FORM_CSV_DOWNLOAD_FAILURE,
  };
}

// API THUNK ACTION CREATORS

export function loadCognitoForms(
  page = 1,
  limit = 10,
  order = null,
  filter = null,
  cb = function () {}
) {
  Logger.log(
    'debug',
    `[state.cognitoForms.actions] loadCognitoForms(${page}, ${limit}, ${order}, %j, ###)`,
    filter
  );

  return async function (dispatch) {
    dispatch(cognitoFormListRequest(page, limit, order, filter));

    // call API
    const response = await api.getCognitoForms(page, limit, order, filter);
    let success = false;
    // get cognito forms list success
    if (200 === response.get('status')) {
      Logger.log(
        'info',
        `Get API cognito forms list success. Page: ${page}, Limit: ${limit}, Order: ${order}.`
      );

      const normalizedEntities = normalize(
        response.getIn(['data', 'cognito_forms']),
        [schema.cognitoForm]
      );
      const data = {
        page: response.getIn(['data', 'page']),
        limit: response.getIn(['data', 'limit']),
        order: order,
        total: response.getIn(['data', 'total']),
        result: normalizedEntities.result,
      };

      dispatch(addEntities(normalizedEntities));
      dispatch(cognitoFormListSuccess(data));
      success = true;
    } else if (1 === page && 204 === response.get('status')) {
      Logger.log(
        'info',
        `Get API cognito forms success [empty]. Page: ${page}, Limit: ${limit}, Order: ${order}.`
      );
      const data = {
        page: page,
        limit: limit,
        order: order,
        total: 0,
        result: [],
      };
      dispatch(cognitoFormListSuccess(data));
      success = true;

      // get cognito forms list failure
    } else {
      Logger.log(
        'info',
        `Get API cognito forms list failure. Page: ${page}, Limit: ${limit}, Order: ${order}.`
      );
      dispatch(cognitoFormListFailure(response.getIn(['data', 'error'])));
    }

    // callback function
    cb(success);
  };
}

export function loadCognitoForm(id, cb = function () {}) {
  Logger.log(
    'debug',
    `[state.cognitoForms.actions] loadCognitoForm(${id}, ###)`
  );

  return async function (dispatch) {
    dispatch(cognitoFormReadRequest(id));

    // call API
    const response = await api.getCognitoForm(id);
    let success = false;

    // get cognito form success
    if (200 === response.get('status')) {
      Logger.log('info', `Get API cognito form success. ID: ${id}.`);

      const normalizedEntities = normalize(
        [response.getIn(['data', 'cognito_form'])],
        [schema.cognitoForm]
      );
      const data = {
        id: response.getIn(['data', 'cognito_form', 'id']),
      };

      dispatch(addEntities(normalizedEntities));
      dispatch(cognitoFormReadSuccess(data));
      success = true;

      // get cognito form failure
    } else {
      Logger.log('info', `Get API cognito form failure. ID: ${id}.`);
      dispatch(cognitoFormReadFailure(response.getIn(['data', 'error'])));
    }

    // callback function
    cb(success);
  };
}

export function updateCognitoForm(id, data, cb = function () {}) {
  Logger.log(
    'debug',
    `[state.cognitoForms.actions] updateCognitoForm(${id}, %j, ###)`,
    data
  );

  return async function (dispatch) {
    dispatch(cognitoFormUpdateRequest(id, data));

    // call API
    const response = await api.putCognitoForm(id, data);
    let success = false;

    // put cognito form success
    if (200 === response.get('status')) {
      Logger.log('info', `PUT API cognito form success. User: ${id}.`);

      const normalizedEntities = normalize(
        [response.getIn(['data', 'cognito_form'])],
        [schema.cognitoForm]
      );
      const data = {
        id: response.getIn(['data', 'cognito_form', 'id']),
      };

      dispatch(addEntities(normalizedEntities));
      dispatch(cognitoFormUpdateSuccess(data));
      success = true;

      // get cognito form failure
    } else {
      Logger.log('info', `PUT API cognito form failure. ID: ${id}.`);
      dispatch(cognitoFormUpdateFailure(response.getIn(['data', 'error'])));
    }

    // callback function
    cb(success);
  };
}

export function createCognitoForm(data, cb = function () {}) {
  Logger.log(
    'debug',
    `[state.cognitoForms.actions] createCognitoForm(%j, ###)`,
    data
  );

  return async function (dispatch) {
    dispatch(cognitoFormCreateRequest(data));

    // call API
    const response = await api.postCognitoForms(data);
    let success = false;

    // post cognito forms success
    if (201 === response.get('status')) {
      Logger.log(
        'info',
        `POST API cognito forms success. Post: ${response.getIn([
          'data',
          'cognito_form',
          'id',
        ])}.`
      );

      const normalizedEntities = normalize(
        [response.getIn(['data', 'cognito_form'])],
        [schema.cognitoForm]
      );
      const data = {
        id: response.getIn(['data', 'cognito_form', 'id']),
      };

      dispatch(addEntities(normalizedEntities));
      dispatch(cognitoFormCreateSuccess(data));
      success = true;

      // get cognito forms failure
    } else {
      Logger.log('info', `POST API cognito forms failure.`);
      dispatch(cognitoFormCreateFailure(response.getIn(['data', 'error'])));
    }

    // callback function
    cb(success);
  };
}

export function deleteCognitoForm(id, cb = function () {}) {
  Logger.log(
    'debug',
    `[state.cognitoForms.actions] deleteCognitoForm(${id}, ###)`
  );

  return async function (dispatch) {
    dispatch(cognitoFormDeleteRequest(id));

    // call API
    const response = await api.deleteCognitoForm(id);
    let success = false;

    // delete cognito form success
    if (204 === response.get('status')) {
      Logger.log('info', `DELETE API cognito form success. ID: ${id}.`);

      dispatch(removeEntity({ entityType: 'cognitoForms', id: id }));
      dispatch(cognitoFormDeleteSuccess(id));
      success = true;

      // get cognito form failure
    } else {
      Logger.log('info', `DELETE API cognito form failure. ID: ${id}.`);
      dispatch(cognitoFormDeleteFailure(response.getIn(['data', 'error'])));
    }

    // callback function
    cb(success);
  };
}

export function downloadCognitoFormsCSV(
  order = null,
  filter = null,
  cb = function () {}
) {
  Logger.log(
    'debug',
    `[state.cognitoForms.actions] downloadCognitoFormsCSV(${order}, ${filter}, ###)`
  );

  return async function (dispatch) {
    dispatch(cognitoFormCSVDownloadRequest(order, filter));

    // call API
    const response = await api.getCognitoFormsCSV(order, filter);
    let success = false;
    // get cognito forms CSV success
    if (200 === response.get('status')) {
      Logger.log('info', `Get API cognito forms CSV success. Order: ${order}`);
      const now = new Date();

      // trigger browser download
      const url = window.URL.createObjectURL(new Blob([response.get('data')]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute(
        'download',
        `cv-cognito-forms-${Format.date(now, 'YYYY-MM-DDTHHmm')}.csv`
      );
      document.body.appendChild(link);
      link.click();

      dispatch(cognitoFormCSVDownloadSuccess());
      success = true;
      // get cognito forms CSV failure
    } else {
      Logger.log('info', `Get API cognito forms CSV failure.`);
      dispatch(cognitoFormCSVDownloadFailure());
    }

    // callback function
    cb(success);
  };
}

Logger.log('silly', `cognitoForms.actions loaded.`);
